import { render, staticRenderFns } from "./RegBtn.vue?vue&type=template&id=16c334e6&scoped=true&"
import script from "./RegBtn.vue?vue&type=script&lang=js&"
export * from "./RegBtn.vue?vue&type=script&lang=js&"
import style0 from "./RegBtn.vue?vue&type=style&index=0&id=16c334e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c334e6",
  null
  
)

export default component.exports